import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Charsets_getInstanceq0o82sizm30g as Charsets_getInstance,
  get_name2f11g4r0d5pxp as get_name,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import { Phases_getInstance153dg9ipormlv as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toList2zksu85ukrmi as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Maps.mjs';
import {
  sortedWith2csnbbb21k0lg as sortedWith,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  Text_getInstance38vnirw8um9kn as Text_getInstance,
  charset1dribv3ku48b1 as charset,
  withCharset27k3t3dvzhi4n as withCharset,
} from '../../../../../ktor-ktor-http/io/ktor/http/ContentTypes.mjs';
import { TextContent1rb6ftlpvl1d2 as TextContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/TextContent.mjs';
import {
  charset3qqtyytkmxogi as charset_0,
  contentType2zzm38yxo3syt as contentType,
} from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { readText27783kyxjxi1g as readText } from '../../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { PrimitiveClasses_getInstance6p7zmos9nw3c as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { readRemaininghtnrfi4c8vp0 as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { TransformResponseBodyContext1axf7xx6ifwbj as TransformResponseBodyContext } from './api/KtorCallContexts.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel2wzou76jce72d as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpPlainText_kt__iy89z1();
  return LOGGER;
}
var LOGGER;
function get_HttpPlainText() {
  _init_properties_HttpPlainText_kt__iy89z1();
  return HttpPlainText;
}
var HttpPlainText;
var HttpPlainTextConfigClass;
function HttpPlainTextConfig() {
  if (HttpPlainTextConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableSetOf' call
        tmp.q5p_1 = LinkedHashSet().x2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.r5p_1 = LinkedHashMap().gc();
        this.s5p_1 = null;
        this.t5p_1 = Charsets_getInstance().e4l_1;
      }
    }
    initMetadataForClass($, 'HttpPlainTextConfig', HttpPlainTextConfig);
    HttpPlainTextConfigClass = $;
  }
  return HttpPlainTextConfigClass;
}
function *_generator_invoke__zhh2q8($this, $this$intercept, content, $completion) {
  var tmp = $this.u5p_1($this$intercept.b4r_1, content, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  if (!(result == null)) {
    var tmp_0 = $this$intercept.d4q(result, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
var RenderRequestHook$install$slambdaClass;
function RenderRequestHook$install$slambda() {
  if (RenderRequestHook$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.u5p_1 = $handler;
      }
      m5g($this$intercept, content, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$intercept, content), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.m5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    RenderRequestHook$install$slambdaClass = $;
  }
  return RenderRequestHook$install$slambdaClass;
}
function RenderRequestHook$install$slambda_0($handler) {
  var i = new (RenderRequestHook$install$slambda())($handler);
  var l = ($this$intercept, content, $completion) => i.m5g($this$intercept, content, $completion);
  l.$arity = 2;
  return l;
}
var RenderRequestHookClass;
function RenderRequestHook() {
  if (RenderRequestHookClass === VOID) {
    class $ {
      v5p(client, handler) {
        var tmp = Phases_getInstance().d5m_1;
        client.p5f_1.f4r(tmp, RenderRequestHook$install$slambda_0(handler));
      }
      f5m(client, handler) {
        return this.v5p(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'RenderRequestHook');
    RenderRequestHookClass = $;
  }
  return RenderRequestHookClass;
}
var RenderRequestHook_instance;
function RenderRequestHook_getInstance() {
  return RenderRequestHook_instance;
}
function HttpPlainTextConfig$_init_$ref_isjudo() {
  var l = () => new (HttpPlainTextConfig())();
  l.callableName = '<init>';
  return l;
}
function HttpPlainText$lambda($this$createClientPlugin) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.collections.sortedByDescending' call
  var this_0 = toList($this$createClientPlugin.o5m_1.r5p_1);
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = HttpPlainText$lambda$lambda;
  var tmp$ret$0 = new (sam$kotlin_Comparator$0())(tmp);
  var withQuality = sortedWith(this_0, tmp$ret$0);
  var responseCharsetFallback = $this$createClientPlugin.o5m_1.t5p_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this$createClientPlugin.o5m_1.q5p_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().u2();
  var _iterator__ex2g4s = tmp0.u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    if (!$this$createClientPlugin.o5m_1.r5p_1.x4(element)) {
      destination.n2(element);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = HttpPlainText$lambda$lambda_0;
  var tmp$ret$5 = new (sam$kotlin_Comparator$0())(tmp_0);
  var withoutQuality = sortedWith(destination, tmp$ret$5);
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_1 = StringBuilder().q1();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = withoutQuality.u1();
  while (_iterator__ex2g4s_0.v1()) {
    var element_0 = _iterator__ex2g4s_0.w1();
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(this_1) > 0) {
      this_1.r1(',');
    }
    this_1.r1(get_name(element_0));
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = withQuality.u1();
  while (_iterator__ex2g4s_1.v1()) {
    var element_1 = _iterator__ex2g4s_1.w1();
    var charset = element_1.df();
    var quality = element_1.ef();
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(this_1) > 0) {
      this_1.r1(',');
    }
    // Inline function 'kotlin.check' call
    if (!(0.0 <= quality ? quality <= 1.0 : false)) {
      throw IllegalStateException().o('Check failed.');
    }
    // Inline function 'kotlin.math.roundToInt' call
    var this_2 = 100 * quality;
    var truncatedQuality = roundToInt(this_2) / 100.0;
    this_1.r1(get_name(charset) + ';q=' + truncatedQuality);
  }
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(this_1) === 0) {
    this_1.r1(get_name(responseCharsetFallback));
  }
  var acceptCharsetHeader = this_1.toString();
  var tmp0_elvis_lhs = $this$createClientPlugin.o5m_1.s5p_1;
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? firstOrNull(withoutQuality) : tmp0_elvis_lhs;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = firstOrNull(withQuality);
    tmp_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.bf_1;
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var tmp3_elvis_lhs = tmp_1;
  var requestCharset = tmp3_elvis_lhs == null ? Charsets_getInstance().e4l_1 : tmp3_elvis_lhs;
  var tmp_2 = RenderRequestHook_instance;
  $this$createClientPlugin.r5m(tmp_2, HttpPlainText$lambda$slambda_0(acceptCharsetHeader, requestCharset));
  $this$createClientPlugin.w5p(HttpPlainText$lambda$slambda_2(responseCharsetFallback));
  return Unit_instance;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.x5p_1 = function_0;
      }
      lh(a, b) {
        return this.x5p_1(a, b);
      }
      compare(a, b) {
        return this.lh(a, b);
      }
      n5() {
        return this.x5p_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.n5(), other.n5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.n5());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function HttpPlainText$lambda$lambda(a, b) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.cf_1;
  var tmp$ret$1 = a.cf_1;
  return compareValues(tmp, tmp$ret$1);
}
function HttpPlainText$lambda$lambda_0(a, b) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = get_name(a);
  var tmp$ret$1 = get_name(b);
  return compareValues(tmp, tmp$ret$1);
}
function invoke$wrapContent(requestCharset, request, content, requestContentType) {
  var contentType = requestContentType == null ? Text_getInstance().o4u_1 : requestContentType;
  var tmp2_elvis_lhs = requestContentType == null ? null : charset(requestContentType);
  var charset_0 = tmp2_elvis_lhs == null ? requestCharset : tmp2_elvis_lhs;
  get_LOGGER().f4s('Sending request body to ' + request.g5g_1.toString() + ' as text/plain with charset ' + charset_0.toString());
  return new (TextContent())(content, withCharset(contentType, charset_0));
}
function invoke$read(responseCharsetFallback, call, body) {
  var tmp0_elvis_lhs = charset_0(call.d5g());
  var actualCharset = tmp0_elvis_lhs == null ? responseCharsetFallback : tmp0_elvis_lhs;
  get_LOGGER().f4s('Reading response body for ' + call.z5h().i5i().toString() + ' as String with charset ' + actualCharset.toString());
  return readText(body, actualCharset);
}
function invoke$addCharsetHeaders(acceptCharsetHeader, context) {
  if (!(context.i5g_1.l2o('Accept-Charset') == null))
    return Unit_instance;
  get_LOGGER().f4s('Adding Accept-Charset=' + acceptCharsetHeader + ' to ' + context.g5g_1.toString());
  context.i5g_1.f4o('Accept-Charset', acceptCharsetHeader);
}
var HttpPlainText$lambda$slambdaClass;
function HttpPlainText$lambda$slambda() {
  if (HttpPlainText$lambda$slambdaClass === VOID) {
    class $ {
      constructor($acceptCharsetHeader, $requestCharset) {
        this.y5p_1 = $acceptCharsetHeader;
        this.z5p_1 = $requestCharset;
      }
      a5q(request, content, $completion) {
        invoke$addCharsetHeaders(this.y5p_1, request);
        if (!(typeof content === 'string'))
          return null;
        var contentType_0 = contentType(request);
        if (!(contentType_0 == null) && !(contentType_0.v4s_1 === Text_getInstance().o4u_1.v4s_1)) {
          return null;
        }
        return invoke$wrapContent(this.z5p_1, request, content, contentType_0);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof HttpRequestBuilder() ? p1 : THROW_CCE();
        return this.a5q(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpPlainText$lambda$slambdaClass = $;
  }
  return HttpPlainText$lambda$slambdaClass;
}
function HttpPlainText$lambda$slambda_0($acceptCharsetHeader, $requestCharset) {
  var i = new (HttpPlainText$lambda$slambda())($acceptCharsetHeader, $requestCharset);
  var l = (request, content, $completion) => i.a5q(request, content, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$transformResponseBody, response, content, requestedType, $completion) {
  if (!requestedType.t4r_1.equals(PrimitiveClasses_getInstance().gg()))
    return null;
  var tmp = readRemaining(content, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var bodyBytes = tmp;
  return invoke$read($this.b5q_1, response.g5i(), bodyBytes);
}
var HttpPlainText$lambda$slambdaClass_0;
function HttpPlainText$lambda$slambda_1() {
  if (HttpPlainText$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($responseCharsetFallback) {
        this.b5q_1 = $responseCharsetFallback;
      }
      c5q($this$transformResponseBody, response, content, requestedType, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$transformResponseBody, response, content, requestedType), $completion);
      }
      d5q(p1, p2, p3, p4, $completion) {
        var tmp = p1 instanceof TransformResponseBodyContext() ? p1 : THROW_CCE();
        var tmp_0 = p2 instanceof HttpResponse() ? p2 : THROW_CCE();
        var tmp_1 = (!(p3 == null) ? isInterface(p3, ByteReadChannel()) : false) ? p3 : THROW_CCE();
        return this.c5q(tmp, tmp_0, tmp_1, p4 instanceof TypeInfo() ? p4 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [4]);
    HttpPlainText$lambda$slambdaClass_0 = $;
  }
  return HttpPlainText$lambda$slambdaClass_0;
}
function HttpPlainText$lambda$slambda_2($responseCharsetFallback) {
  var i = new (HttpPlainText$lambda$slambda_1())($responseCharsetFallback);
  var l = ($this$transformResponseBody, response, content, requestedType, $completion) => i.c5q($this$transformResponseBody, response, content, requestedType, $completion);
  l.$arity = 4;
  return l;
}
var properties_initialized_HttpPlainText_kt_2nx4ox;
function _init_properties_HttpPlainText_kt__iy89z1() {
  if (!properties_initialized_HttpPlainText_kt_2nx4ox) {
    properties_initialized_HttpPlainText_kt_2nx4ox = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpPlainText');
    var tmp = HttpPlainTextConfig$_init_$ref_isjudo();
    HttpPlainText = createClientPlugin('HttpPlainText', tmp, HttpPlainText$lambda);
  }
}
//region block: init
RenderRequestHook_instance = new (RenderRequestHook())();
//endregion
//region block: exports
export {
  get_HttpPlainText as get_HttpPlainText2hd9sygnz4kij,
};
//endregion

//# sourceMappingURL=HttpPlainText.mjs.map
